module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"authentication":"Authentication","connectWithIdentityProviders":"Connect with ...","loginError":"Bad identifier or password. Connection refused"},"fr":{"authentication":"Authentification","connectWithIdentityProviders":"Connexion avec ...","loginError":"Mauvais identifiant ou mot de passe. Connexion refusée"}}')
  delete Component.options._Ctor
}
